import { api } from './api';
import {
  InventoryItem,
  InventoryFilters,
  StorageSummaryItem,
  StorageSummaryFilters,
  InventoryTransaction,
  InventoryTransactionFilters,
  PaginatedResponse,
} from '../types';

export const inventoryService = {
  getInventory: async (filters?: InventoryFilters): Promise<PaginatedResponse<InventoryItem>> => {
    const params = new URLSearchParams();
    
    if (filters) {
      if (filters.page) params.append('page', filters.page.toString());
      if (filters.limit) params.append('limit', filters.limit.toString());
      if (filters.search) params.append('q', filters.search);
      if (filters.clientId) params.append('clientId', filters.clientId.toString());
      if (filters.productCategoryId) params.append('productCategoryId', filters.productCategoryId.toString());
    }
    
    const response = await api.get<{ items: InventoryItem[], meta: any }>(`/inventory?${params}`);
    
    return {
      data: response.data.items,
      total: response.data.meta.total,
      page: response.data.meta.page,
      limit: response.data.meta.limit,
      totalPages: response.data.meta.totalPages,
      hasNext: response.data.meta.page < response.data.meta.totalPages,
      hasPrev: response.data.meta.page > 1,
    };
  },
  
  getClientInventory: async (clientId: number, filters?: Omit<InventoryFilters, 'clientId'>): Promise<PaginatedResponse<InventoryItem>> => {
    const params = new URLSearchParams();
    
    if (filters) {
      if (filters.page) params.append('page', filters.page.toString());
      if (filters.limit) params.append('limit', filters.limit.toString());
      if (filters.search) params.append('search', filters.search);
      if (filters.productCategoryId) params.append('productCategoryId', filters.productCategoryId.toString());
    }
    
    const response = await api.get<{ items: InventoryItem[], meta: any }>(`/inventory/client/${clientId}?${params}`);
    
    return {
      data: response.data.items,
      total: response.data.meta.total,
      page: response.data.meta.page,
      limit: response.data.meta.limit,
      totalPages: response.data.meta.totalPages,
      hasNext: response.data.meta.page < response.data.meta.totalPages,
      hasPrev: response.data.meta.page > 1,
    };
  },
  
  getStorageSummary: async (filters: StorageSummaryFilters): Promise<StorageSummaryItem[]> => {
    const params = new URLSearchParams();
    params.append('clientId', filters.clientId.toString());
    params.append('productDescription', filters.productDescription);
    if (filters.batchNo) {
      params.append('batchNo', filters.batchNo);
    }
    
    const response = await api.get<{ items: StorageSummaryItem[], meta: any }>(`/inventory-summary/storage?${params}`);
    return response.data.items;
  },
  
  getTransactions: async (filters?: InventoryTransactionFilters): Promise<PaginatedResponse<InventoryTransaction>> => {
    const params = new URLSearchParams();
    
    if (filters) {
      if (filters.page) params.append('page', filters.page.toString());
      if (filters.limit) params.append('limit', filters.limit.toString());
      if (filters.search) params.append('search', filters.search);
      if (filters.clientId) params.append('clientId', filters.clientId.toString());
      if (filters.transactionType) params.append('transactionType', filters.transactionType);
      if (filters.startDate) params.append('startDate', filters.startDate);
      if (filters.endDate) params.append('endDate', filters.endDate);
      if (filters.productDescription) params.append('productDescription', filters.productDescription);
      if (filters.batchNo) params.append('batchNo', filters.batchNo);
    }
    
    const response = await api.get<{ items: InventoryTransaction[], meta: any }>(`/inventory/transactions?${params}`);
    
    return {
      data: response.data.items,
      total: response.data.meta.total,
      page: response.data.meta.page,
      limit: response.data.meta.limit,
      totalPages: response.data.meta.totalPages,
      hasNext: response.data.meta.page < response.data.meta.totalPages,
      hasPrev: response.data.meta.page > 1,
    };
  },
};
